import siteData from "../data/siteData.json";
import "./Gallery.css";
import Modal from "react-modal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

Modal.setAppElement("#root");

export default function Gallery() {
  const [selectedImg, setSelectedImg] = useState(null);
  const navigate = useNavigate();

  // Marquee trick: duplicate array to create seamless loop
  const images = [...siteData.galleryImages, ...siteData.galleryImages];

  return (
    <section id="gallery" className="gallery-section">

      {/* ===== TITLE + VIEW ALL (NO UI BREAK) ===== */}
      <div className="gallery-top">
        <h2 className="section-heading">Project Gallery</h2>
        <button
          className="view-all-btn"
          onClick={() => navigate("/gallery")}
        >
          View All →
        </button>
      </div>

      <div className="marquee">
        <div className="track">
          {images.map((item, index) => (
            <div
              className="gallery-card"
              key={index}
              onClick={() => setSelectedImg(item.image)}
            >
              <img src={item.image} alt="gallery" />
            </div>
          ))}
        </div>
      </div>

      {/* POPUP IMAGE VIEW */}
      <Modal
        isOpen={!!selectedImg}
        onRequestClose={() => setSelectedImg(null)}
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <div className="modal-inner">
          <img src={selectedImg} alt="popup" className="modal-img" />
          <button className="close-btn" onClick={() => setSelectedImg(null)}>
            ✕
          </button>
        </div>
      </Modal>
    </section>
  );
}
